import React, { Component } from 'react'
import "../../../../css/general-style.css"
import '../../../../css/small-table-responsive.css'
import '../../../PreSaleOrdersList.css'
import { DateFormatMAS90 } from '../../../../functions/dateFormat';
import { NumberFormat } from '../../../../functions/generalFunctions';
import { pricesFormat } from '../../../../functions/pricesFormat';
import { AiOutlineClockCircle, AiOutlineWarning } from 'react-icons/ai';

export default class extends Component {
    constructor(props) {
        super(props);
        this.ModalLoading = React.createRef();
    }
    
    state = {

    }

    selectColor(number) {
        if (number >= 0 && number <= 14) {
            return "status-success"
        } else if (number >= 15 && number <= 29) {
            return "status-warning"
        } else if (number >= 3) {
            return "status-danger"
        }
                
        return ""
    }


    render() {
        // Get request status
        const { loading, error, Title } = this.props;

        if (loading) {
            return (
                <div className="card card-skeleton">
                    <div className="skeleton-header" />
                    <div className="skeleton-row" />
                    <div className="skeleton-row" />
                    <div className="skeleton-row" />
                </div>
            );
        }

        if (error) {
            return (
                <div className="card card-error">
                    <h4>{Title}</h4>
                    <p>{error}</p>
                </div>
            );
        }

        return (
            <div>
                <div className='col-12'>
                    <div className='row'>
                        <div className='col-sm-12 col-md-6 col-lg-6 text-center mb-3'>
                            <div className='metric-card status-success'>
                                <p className='metric-label'><AiOutlineClockCircle style={{marginRight:4}}/> 0–14 Days</p>

                                {this.props.Totals.TotalR1 && this.props.Totals.TotalDueInv ?
                                    <div className='metric-value'>
                                        {pricesFormat((this.props.Totals.TotalR1 / this.props.Totals.TotalDueInv)*100)} %
                                    </div>
                                :
                                    <div className='metric-value'>0 %</div>
                                }

                                <div className='metric-change status-success'>{NumberFormat(this.props.Totals.Range1)+" inv · $"}{NumberFormat(pricesFormat(this.props.Totals.TotalR1))}</div>
                            </div>
                        </div>
                        <div className='col-sm-12 col-md-6 col-lg-6 text-center mb-3'>
                            <div className='metric-card status-warning'>
                                <p className='metric-label'><AiOutlineClockCircle style={{marginRight:4}}/> 15–29 Days</p>

                                {this.props.Totals.TotalR2 && this.props.Totals.TotalDueInv ?
                                    <div className='metric-value'>
                                        {pricesFormat((this.props.Totals.TotalR2 / this.props.Totals.TotalDueInv)*100)} %
                                    </div>
                                :
                                    <div className='metric-value'>0 %</div>
                                }

                                <div className='metric-change status-warning'>{NumberFormat(this.props.Totals.Range2)+" inv · $"}{NumberFormat(pricesFormat(this.props.Totals.TotalR2))}</div>
                            </div>
                        </div>
                        <div className='col-sm-12 col-md-6 col-lg-6 text-center mb-3'>
                            <div className='metric-card status-danger'>
                                <p className='metric-label'><AiOutlineWarning style={{marginRight:4}}/> +30 Days</p>

                                {this.props.Totals.TotalR3 && this.props.Totals.TotalDueInv ?
                                    <div className='metric-value'>
                                        {pricesFormat((this.props.Totals.TotalR3 / this.props.Totals.TotalDueInv)*100)} %
                                    </div>
                                :
                                    <div className='metric-value'>0 %</div>
                                }

                                <div className='metric-change status-danger'>{NumberFormat(this.props.Totals.Range3)+" inv · $"}{NumberFormat(pricesFormat(this.props.Totals.TotalR3))}</div>
                            </div>
                        </div>
                        <div className='col-sm-12 col-md-6 col-lg-6 text-center mb-3'>
                            <div className='metric-card status-primary'>
                                <p className='metric-label'>Total Overdue</p>
                                <div className='metric-value'>${NumberFormat(pricesFormat(this.props.Totals.TotalDueInv))}</div>
                            </div>
                        </div>
                    </div>
                    
                    <div className='card'>
                        <div className='card-body'>
                            <div className='row'>
                                <div className='col-sm-12'>
                                    <h6 className='card-title-clean mb-0'>{this.props.Title}</h6>
                                </div>
                                <div className='col-sm-12'>
                                    <div className='pb-3' />

                                    {/* Vertical-only scroll, one card per invoice (2026-09-09
                                        redesign, client's ask: no horizontal scroll). Balance
                                        sign still drives the accent color, just as a left
                                        border now instead of a full-row background. */}
                                    <div style={{ maxHeight: '55vh', overflowY: 'auto', paddingRight: '2px' }}>
                                        {(this.props.data || []).slice(0, 400).map((order, o) => (
                                            <div key={`pd${o}`} className='pol-card'
                                                style={{ borderLeft: `4px solid ${Number(order.Balance) >= 0 ? '#10b981' : '#EF4444'}`, padding: '14px 16px', marginBottom: '10px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: '10px', flexWrap: 'wrap', marginBottom: '12px' }}>
                                                    <strong style={{ fontSize: '0.95rem', color: '#0F172A' }}>{order.CustomerName}</strong>
                                                    <strong style={{ fontSize: '1.05rem', color: '#2563EB' }}>${NumberFormat(pricesFormat(order.Balance))}</strong>
                                                </div>
                                                <div className='pol-card__grid' style={{ gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' }}>
                                                    <div className='pol-kv-box'>
                                                        <span>Invoice No</span>
                                                        <strong>{order.InvoiceNo}</strong>
                                                    </div>
                                                    <div className='pol-kv-box'>
                                                        <span>Customer No</span>
                                                        <strong>{order.CustomerNo}</strong>
                                                    </div>
                                                    <div className='pol-kv-box'>
                                                        <span>Due Date</span>
                                                        <strong>{DateFormatMAS90(order.InvoiceDueDate)}</strong>
                                                    </div>
                                                    <div className='pol-kv-box'>
                                                        <span><AiOutlineClockCircle style={{ marginRight: 4 }} />Days Dlq</span>
                                                        <span className={`dash-days-badge ${this.selectColor(Number(order.DaysDlq))}`}>
                                                            {order.DaysDlq}d
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
